import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as accountActions from "Actions/accountActions";
import PolicyPayOptions from "./PolicyPayOptions";

function mapStateToProps(state) { 
    return {
        accounts: state.accounts.accounts,
        isIEFlag: state.accounts.isIEFlag,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(accountActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyPayOptions);



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PolicyPayOptions/index.js